import {Component, Input, OnInit} from '@angular/core';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';
import {FunctionRating} from 'shared/dtos/function-rating';
import {Funktionsmatrix} from '../funktionsmatrix.interface';

@Component({
  selector: 'app-current-codes-table',
  templateUrl: './current-codes-table.component.html',
  styleUrl: './current-codes-table.component.scss',
  standalone: false
})
export class CurrentCodesTableComponent extends CurrentLocaleComponent {
  @Input() data: Funktionsmatrix;
  @Input() funktionen: FunctionRating[];

  getFunktionName(id: string | number) {
    // eslint-disable-next-line eqeqeq
    return this.funktionen.find(f => f.value == id)?.caption;
  }
}
